import { NORNE_CENTERID } from "@portal/assets/banks";

export const IsNorne = (centerId: string) => {
  return centerId === "" || centerId === NORNE_CENTERID;
};
